import React from "react";
import { withStyles } from "@material-ui/core";
import ActionButtons from "features/shared/components/actionButtons";
import { useTranslations } from "adapters/i18n";


const PendencyEditButtons = ({
  classes,
  onGoBack = () => {},
  onSubmit = () => {},
  isSaveEnabled,
}) => {
  const { t } = useTranslations();
  return (
    <div className={classes.buttonsContainer}>
      <ActionButtons
        className={classes.actionButtons}
        onSubmit={onSubmit}
        onBack={onGoBack}
        enableButtonSubmit={isSaveEnabled}
        textButtonSubmit={t("pendency:save-and-apply")}
        textButtonGoBack={t("common:actions.cancel")}
        tooltipMessage={!true && t("pendency:to-resolve-pendency-tooltip")}
      />
    </div>
  );
};

const styles = () => ({
  buttonsContainer: {
    display: "flex",
    marginTop: "auto",
  },
  actionButtons: {
    marginTop: 32,
  },
});

export default withStyles(styles)(PendencyEditButtons);
